import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import PageTransition from 'gatsby-v2-plugin-page-transitions';

import Page from '../components/global/page';
import Section from '../components/global/section';
import Hero from '../components/hero';

const StyledPrivacy = styled.div`
	section {
		padding: 4rem 0;
		h1 {
			margin-bottom: 1rem;
		}
		h2 {
			font-size: 1.5rem;
			margin-top: 2rem;
			margin-bottom: 1rem;
		}
		p {
			margin-bottom: 1em;
		}
		a {
			color: ${(p) => p.theme.color.red};
			border-bottom: 1px solid transparent;
			transition: 300ms;

			&:hover {
				color: ${(p) => p.theme.color.green};
				border-bottom-color: ${(p) => p.theme.color.green};
			}
		}
		ul {
			padding: 1rem 0;
			li {
				line-height: 1.5rem;
				margin-left: 1rem;
				position: relative;
				&::before {
					content: '';
					background-color: #000;
					height: 7px;
					width: 7px;
					border-radius: 7px;
					position: absolute;
					left: -1rem;
					top: 8px;
				}
			}
		}
		@media all and (max-width: 500px) {
			padding: 2rem 0 3rem;
		}
	}
`;

export default () => (
	<PageTransition>
		<Page
			title="Privacy Policy"
			desc="We value yout privacy. Learn about Start Talking's privacy policies and proceedures."
		>
			<StyledPrivacy>
				<Hero img="/img/purple-grass.svg" alt="purple grass" />
				<Section bg="white">
					<div>
						<h1>Privacy Policy</h1>
						<h2>What information do we collect?</h2>
						<p>
							We collect information from you when you fill out a form. When
							ordering or registering on our site, as appropriate, you may be
							asked to enter your: name, e-mail address, mailing address or
							phone number.
						</p>

						<h2>What do we use your information for?</h2>
						<p>
							Any of the information we collect from you may be used in one of
							the following ways:
						</p>
						<ul>
							<li>
								To administer a contest, promotion, survey or other site feature
							</li>
							<li>To send periodic emails</li>
						</ul>

						<h2>How do we protect your information?</h2>
						<p>
							We implement a variety of security measures to maintain the safety
							of your personal information when you enter, submit, or access
							your personal information.
						</p>

						<p>
							We offer the use of a secure server. All supplied sensitive/credit
							information is transmitted via Secure Socket Layer (SSL)
							technology and then encrypted into our Payment gateway providers
							database only to be accessible by those authorized with special
							access rights to such systems, and are required to?keep the
							information confidential.
						</p>
						<p>
							After a transaction, your private information (credit cards,
							social security numbers, financials, etc.) will not be kept on
							file for more than 60 days.
						</p>

						<h2>Do we use cookies?</h2>
						<p>We do not use cookies.</p>
						<h2>Do we disclose any information to outside parties?</h2>
						<p>
							We do not sell, trade, or otherwise transfer to outside parties
							your personally identifiable information. This does not include
							trusted third parties who assist us in operating our website,
							conducting our business, or servicing you, so long as those
							parties agree to keep this information confidential.
						</p>

						<h2>Third party links</h2>
						<p>
							Occasionally, at our discretion, we may include or offer third
							party products or services on our website. These third party sites
							have separate and independent privacy policies. We therefore have
							no responsibility or liability for the content and activities of
							these linked sites. Nonetheless, we seek to protect the integrity
							of our site and welcome any feedback about these sites.
						</p>
						<h2>Online Privacy Policy Only</h2>
						<p>
							This online privacy policy applies only to information collected
							through our website and not to information collected offline.
						</p>

						<h2>Terms and Conditions</h2>
						<p>
							Please also{' '}
							<Link to="/terms/">visit our Terms and Conditions</Link> section
							establishing the use, disclaimers, and limitations of liability
							governing the use of our website.
						</p>
						<h2>Changes to our Privacy Policy</h2>
						<p>
							If we decide to change our privacy policy, we will post those
							changes on this page.
						</p>
					</div>
				</Section>
			</StyledPrivacy>
		</Page>
	</PageTransition>
);
